<template>
  <form
    autocomplete="on"
    class="form-horizontal container px-0"
    @submit="onSubmit"
  >
    <h3><i class="fas fa-building"></i> Pyme</h3>
    <div class="alert alert-danger" v-if="error">{{ error }}</div>
    <div class="row">
      <div class="form-group col-12">
        <label for="nombre_de_contacto">Nombre de contacto</label>
        <span v-if="errors.nombreContacto && touched.nombreContacto" class="formError">{{ errors.nombreContacto }}</span>
        <input
          placeholder="Nombre de contacto"
          @input="validate"
          @blur="handleTouched"
          type="text"
          id="nombre-de-contacto"
          name="nombreContacto"
          v-model="form.nombreContacto"
          class="form-control"
        >
      </div>
      <div class="form-group col-12">
        <label for="cargo">Cargo</label>
        <input 
          placeholder="Cargo"
          type="text"
          id="cargo"
          name="cargo"
          class="form-control col-12"
          v-model="form.cargo"
        >
      </div>
      <div class="form-group col-12">
        <label for="email">Email</label>
        <span v-if="errors.email && touched.email" class="formError">{{ errors.email }}</span>
        <input
          placeholder="Email"
          @input="validate"
          @blur="handleTouched"
          type="email"
          id="email"
          name="email"
          v-model="form.email"
          class="form-control"
          autocomplete="email"
        />
      </div>

      <div class="form-group col-12">
        <label for="confirmar_email">Confirmar email</label>
        <input
          type="email"
          id="confirmar_email"
          v-model="form.confirmarEmail"
          class="form-control"
          placeholder="Confirmar Email"
        />
      </div>
    </div>
    <div class="row">
      <div class="form-group col-12">
        <label for="password">Contraseña</label>
        <span v-if="errors.password && touched.password" class="formError">{{ errors.password }}</span>
        <input
          placeholder="Contraseña"
          @input="validate"
          @blur="handleTouched"
          type="password"
          name="password"
          id="password"
          v-model="form.password"
          class="form-control"
          autocomplete="password"
        />
      </div>

      <div class="form-group col-12">
        <label for="confirmar_password">Confirmar contraseña</label>
        <input
          type="password"
          id="confirmar_password"
          v-model="form.confirmarPassword"
          class="form-control"
          placeholder="Confirmar Contraseña"
        />
      </div>
    </div>
    <div class="row">
      <div class="form-group col-12">
        <label for="razon_social">Razón Social</label>
        <span v-if="errors.razonSocial && touched.razonSocial" class="formError">{{ errors.razonSocial }}</span>
        <input
          @blur="handleTouched"
          @input="validate"
          type="text"
          name="razonSocial"
          id="razon_social"
          class="form-control"
          v-model="form.razonSocial"
        />
      </div>
      <div class="form-group col-12">
        <label for="cuit">CUIT</label>
        <span v-if="errors.cuit && touched.cuit" class="formError">{{ errors.cuit }}</span>
        <input
          @input="validate"
          @blur="handleTouched"
          type="text"
          name="cuit"
          id="cuit"
          class="form-control col-12"
          v-model="form.cuit"
        />
      </div>
      <div class="form-group col-12">
        <label for="rubro">Rubro</label>
        <span v-if="errors.rubro && touched.rubro" class="formError">{{ errors.rubro }}</span>
        <input
          @input="validate"
          @blur="handleTouched"
          type="text"
          name="rubro"
          id="rubro"
          class="form-control col-12"
          v-model="form.rubro"
        />
      </div>
      <div class="form-group col-12">
        <label for="categoria">Categoría</label>
        <span v-if="errors.categoria && touched.categoria" class="formError">{{ errors.categoria }}</span>
        <input
          @input="validate"
          @blur="handleTouched"
          type="text"
          name="categoria"
          id="categoria"
          class="form-control col-12"
          v-model="form.categoria"
        />
      </div>
      <div class="form-group col-12">
        <label for="telefono">Teléfono</label>
        <span v-if="errors.telefono && touched.telefono" class="formError">{{ errors.telefono }}</span>
        <input
          @input="validate"
          @blur="handleTouched"
          type="tel"
          name="telefono"
          class="form-control" 
          v-model="form.telefono" 
          />
      </div>
    </div>
    <div class="col-12 pb-3 alert alert-success">
      <div class="form-check">
        <input
          v-model="sameAddress"
          type="checkbox"
          class="form-check-input"
          id="domicilio-iguales"
        />
        <label class="form-check-label" for="domicilio-iguales"
          ><i class="fas fa-map-marker-alt"></i> Mi domicilio de envio y legal
          son iguales</label
        >
      </div>
    </div>
    <domicilio
      :titulo="
        sameAddress
          ? 'Domicilio Legal y Domicilio Entrega'
          : 'Domicilio Entrega'
      "
      v-model="form.domicilio"
    ></domicilio>
    <domicilio
      v-if="!sameAddress"
      :autocomplete="false"
      titulo="Domicilio Legal"
      v-model="form.domicilioLegal"
    ></domicilio>
    <div class="row">
      <div class="form-group col-12">
        <label for="referencia" class="col-sm-12 control-label"
          >¿Cómo llegaste a SAREXPRESS?</label
        >
        <select id="referencia" v-model="form.referencia" class="form-control">
          <option disabled selected>Seleccione opción...</option>
          <option>Un amigo o familiar me habló del servicio</option>
          <option>A través de Google</option>
        </select>
      </div>
    </div>
    <terminos-y-condiciones
      :value="terminosYCondiciones"
      :onTerminosPressed="onTerminosPressed"
    ></terminos-y-condiciones>

    <div class="row">
      <div class="col-12 pt-2 pb-1">
        <button
          type="submit"
          :disabled="loading"
          class="btn btn-primary btn-block"
        >
          Registrarse
        </button>
      </div>
    </div>
  </form>
</template>
<script>
import Domicilio from "./Domicilio";
import { createPymeClient } from "../../service/api";
import TerminosYCondiciones from "./TerminosYCondiciones.vue";
import {validateRequiredFields,errorMessages} from '../../constants'

export default {
  props: { onSuccess: { type: Function } },
  components: { Domicilio, TerminosYCondiciones },
  methods: {
    onTerminosPressed() {
      this.terminosYCondiciones = !this.terminosYCondiciones;
    },
    validate(){
      this.errors = {
        nombreContacto:'',
        email:'',
        password:'',
        razonSocial:'',
        cuit:'',
        rubro:'',
        categoria:'',
        telefono:'',
      }
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(this.form.email)) {
        this.errors.email = errorMessages.invalidEmail;
      }
      if (!/^[0-9-]*$/.test(this.form.cuit)){
        this.errors.cuit=errorMessages.invalidCuit
      }
      console.log(this.form)
      validateRequiredFields(['nombreContacto','email','razonSocial','cuit','rubro','categoria','telefono','password'],this.form,this.errors)
    },
    handleTouched(e){
      this.touched[e.target.name]=true
    },

    async onSubmit(evt) {
      evt.preventDefault();
      this.error = null;
      if (this.form.email !== this.form.confirmarEmail) {
        window.scrollTo(0, 0);
        return (this.error = "Los emails no coinciden");
      }
      if(this.form.password !== this.form.confirmarPassword) {
        window.scrollTo(0,0);
        return this.error = "Las contraseñas no coinciden"
      }
      if (!this.terminosYCondiciones) {
        window.scrollTo(0, 0);
        return (this.error = "Debe aceptar los términos y condiciones");
      }

      let isValid=true

      Object.keys(this.errors).map(key=>{
        if (this.errors[key]){
          isValid=false
        }
      })

      if (isValid===false||this.form.domicilio.isValid===false||(this.sameAddress===false&&this.form.domicilioLegal.isValid===false)){
        window.scrollTo(0, 0);
        return (this.error = "Hay errores en el formulario, revisar e intentar nuevamente");
      }

      if (!this.loading) {
        this.loading = true;
        let domicilioLegal = this.sameAddress
          ? this.form.domicilio
          : this.form.domicilioLegal;
        try {
          const response = await createPymeClient({
            cuit: this.form.cuit,
            rubro: this.form.rubro,
            categoria: this.form.categoria,
            razon_social: this.form.razonSocial,
            telefono: this.form.telefono,
            como_llegaste: this.form.referencia,
            password: this.form.password,
            nombre_contacto: this.form.nombreContacto,
            cargo_nombre_contacto: this.form.cargo,
            user: {
              username: this.form.email,
            },
            domicilio: {
              direccion: this.form.domicilio.direccion,
              piso: this.form.domicilio.piso,
              departamento: this.form.domicilio.departamento,
              codigo_postal: this.form.domicilio.codigoPostal,
              ciudad: this.form.domicilio.ciudad,
              provincia: this.form.domicilio.provincia,
            },
            domicilio_legal: {
              direccion: domicilioLegal.direccion,
              piso: domicilioLegal.piso,
              departamento: domicilioLegal.departamento,
              codigo_postal: domicilioLegal.codigoPostal,
              ciudad: domicilioLegal.ciudad,
              provincia: domicilioLegal.provincia,
            },
          })

          console.log('Response:', response)
          this.loading = false;
          this.error = null;
          if (response.status >= 200 && response.status < 300) {
            this.onSuccess();
          }

        } catch (error) {
          const errors = Object.values(error.response.data)
          this.loading = false;
          this.error = error.response.data ? errors[0] : "Ocurrio un error, intentelo más tarde"
          window.scrollTo(0, 0);
          
        }
      }
    },
  },
  data() {
    return {
      terminosYCondiciones: false,
      error: null,
      errors: {
        nombreContacto:errorMessages.required,
        email:errorMessages.required,
        password:errorMessages.required,
        razonSocial:errorMessages.required,
        cuit:errorMessages.required,
        rubro:errorMessages.required,
        categoria:errorMessages.required,
        telefono:errorMessages.required,
      },
      touched:{
        nombreContacto:false,
        email:false,
        password:false,
        razonSocial:false,
        cuit:false,
        rubro:false,
        categoria:false,
        telefono:false,
      },
      loading: false,
      sameAddress: false,
      form: {
        nombreContacto:"",
        cargo:"",
        email: "",
        confirmarEmail: "",
        cuit: "",
        rubro: "",
        categoria: "",
        telefono: "",
        referencia: "Seleccione opción...",
        confirmarPassword: "",
        password: "",
        domicilio: {
          direccion: "",
          piso: "",
          departamento: "",
          codigoPostal: "",
          ciudad: "",
          provincia: "",
          isValid:false,
        },
        domicilioLegal: {
          direccion: "",
          piso: "",
          departamento: "",
          codigoPostal: "",
          ciudad: "",
          provincia: "",
          isValid:false,
        },
      },
    };
  },
};
</script>